import { store } from "../../../../app/store";

export const handlePublish = (
  patchWorkbook
) => {

  // Get the current Redux state
  const currentState = store.getState().Workbook.present;

  const chartSheetsArray = currentState.sheets.filter((sheet) => sheet.sheetType === "chart");
  console.log("Chart Sheets Array:", chartSheetsArray);

  const dashboardSheetsArray = currentState.sheets.filter((sheet) => sheet.sheetType === "dashboard");
  console.log("Dashboard Sheets Array (Before Update):", dashboardSheetsArray);

  const chartSheetMap = chartSheetsArray.reduce((map, chartSheet) => {
    map[chartSheet.ID] = chartSheet.SheetName;
    return map;
  }, {});
  const updatedDashboardSheetsArray = dashboardSheetsArray.map((dashboardSheet) => {
    const updatedSheetsArray = dashboardSheet.SheetsArray.map((sheet) => ({
      ...sheet,
      SheetName: chartSheetMap[sheet.Sheetid] || sheet.SheetName,
    }));

    return {
      ...dashboardSheet,
      SheetsArray: updatedSheetsArray,
    };
  });

  console.log("Dashboard Sheets Array (After Update):", updatedDashboardSheetsArray);

  // Prepare the final sheets array
  const finalSheets = [
    ...chartSheetsArray, // Include chart sheets as is
    ...updatedDashboardSheetsArray, // Include updated dashboard sheets
  ];

  // Check if imageURL is defined or not null, and if currentState exists
  const payload = {
    workbookId: currentState._id,
    workbookData: {
      name: currentState.name,
      draftId: currentState._id,
      commonFilters: currentState.commonFilters,
      hierarchy: currentState.hierarchy,
      selectedSheetId: currentState.selectedSheetId,
      calculatedFields: currentState.calculatedFields,
    },
    sheetsData: finalSheets,
  };
  console.log(finalSheets);  
  // Call the patchWorkbook function with the payload
  patchWorkbook(payload);
};
